import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { VENUE } from "../lib/venue";

const links = [
  { href: "#whats-on", label: "What's On" },
  { href: "#events", label: "Upcoming" },
  { href: "#hire", label: "Private Hire" },
  { href: "#gallery", label: "Gallery" },
  { href: "#visit", label: "Visit" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/85 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src={VENUE.logoUrl}
            alt="The Bar Colac — Colac pub and live music venue"
            className="h-12 w-12 object-contain"
          />
          <span className="font-display text-2xl tracking-wider text-[#FDFBF7] hidden sm:inline">
            THE BAR
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FDFBF7]/80 hover:text-[#F5A623] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#events"
          data-testid="nav-cta-events"
          className="hidden md:inline-flex items-center bg-[#F5A623] hover:bg-amber-400 text-black font-bold uppercase tracking-wider text-xs px-5 py-3 transition-all border-2 border-[#F5A623]"
        >
          See Events
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#FDFBF7] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 border-t border-white/10">
          <ul className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="block text-sm uppercase tracking-[0.2em] font-semibold text-[#FDFBF7]/90 hover:text-[#F5A623]"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};
